<template>
  <div id="page-user-list" class="vx-card p-6">
    <!-- Title and Buttons Action -->
    <div class="text-title">
      <span></span>
    </div>
    <!-- <vs-row class="pl-2">
          <vs-col class="flex flex-wrap items-center md:justify-end justify-evenly" vs-w="12">
            <vs-button :disabled="ids.length > 0 ? false:true" color="danger" icon="delete" @click="activeDelete = true">削除</vs-button>
            <vs-button color="success" icon="playlist_add" @click="setUpCreate">登録</vs-button>
          </vs-col>
        </vs-row> -->

    <vs-popup
      id="dialogDeleted"
      title="Delete setting"
      :active.sync="activeDelete"
      button-close-hidden
    >
      <div>
        <span>選択された設定を削除しますか？</span>
      </div>
      <div class="flex justify-end mt-4">
        <vs-button
          @click="confirmDelete"
          icon="delete"
          color="danger"
          class="mx-2"
          >削除</vs-button
        >
        <vs-button @click="activeDelete = false" icon="cancel" color="lightgrey"
          >キャンセル</vs-button
        >
      </div>
    </vs-popup>

    <!-- Create and Edit Dialog -->
    <vs-popup
      id="dialogUpdate"
      :title="title"
      :active.sync="activePopup"
      button-close-hidden
    >
      <div>
        <div>
          <vx-card
            :title="key!='mail_time_sync'?'制限設定':'バッチ実行スケジュール'"
            card-background="rgb(240, 238, 241)"
            height="420px"
            class="pb-2"
            style="font-size: 12px"
          >
            <div>
              <vs-row>
                <vs-col class="flex items-center" vs-w="3">
                  <span>Key<span style="color: red">*</span></span>
                </vs-col>
                <vs-col vs-w="9">
                  <vs-row>
                    <vs-input
                      v-validate.immediate="'required'"
                      maxlength="256"
                      name="keys"
                      v-model="key"
                      class="w-full mb-2"
                      disabled
                    />
                  </vs-row>
                </vs-col>
                <vs-col class="flex items-center" vs-w="3">
                  <span>Value<span style="color: red">*</span></span>
                </vs-col>
                <vs-col vs-w="9">
                  <vs-row v-if="key == 'column_limit' || key == 'maximum_size_attachment'">
                    <vs-input
                      v-validate.immediate="key == 'maximum_size_attachment' ? 'required|port|numeric|maxfilesize:' + upload_max_filesize : 'required|port'"
                      name="Value"
                      v-model="value"
                      class="w-full mb-2"
                    />
                    <span  v-if="key == 'maximum_size_attachment'" style="color: red">{{ errors.first("Value") | convertError }}</span>
                  </vs-row>
                  <vs-row v-else>
                    <vs-input
                      v-validate.immediate="'required'"
                      name="Value"
                      v-model="value"
                      class="w-full mb-2"
                      v-if="key!='mail_time_sync'"
                    />
                    <flat-pickr id="time_sync_mail_server"
                                class="w-full flatpickr-style"
                                v-model="value"
                                placeholder="..."
                                v-else
                                :config="configDate">
                    </flat-pickr>
                  </vs-row>
                  <span v-show="submitted" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("Value ") | convertError }}</span>
                </vs-col>
                <vs-col class="flex items-center" vs-w="3">
                  <span>備考<span style="color: red">*</span></span>
                </vs-col>
                <vs-col vs-w="9">
                  <vs-row>
                    <vs-input
                      v-validate.immediate="'required'"
                      maxlength="256"
                      name="keys"
                      v-model="explanation"
                      class="w-full mb-2"
                    />
                  </vs-row>
                </vs-col>
              </vs-row>
              <vs-row>
                <vs-col vs-offset="3">
                  <span
                    v-show="submitted"
                    class="mb-2 text-danger font-size-info"
                    style="display: block"
                    >{{ errors.first("Key") | convertError }}</span
                  >
                </vs-col>
              </vs-row>
            </div>
          </vx-card>
        </div>
        <div style="display: flex; justify-content: flex-end" class="pt-4">
          <vs-button
            v-if="title != '設定更新'"
            @click="actionCreate"
            :disabled="!validateForm && submitted"
            icon="person_add"
            color="success"
            style="padding: 8px; margin-right: 5px; height: 37px"
            >登録</vs-button
          >
          <vs-button
            v-else
            @click="actionUpdate"
            :disabled="!validateForm"
            icon="assignment"
            color="success"
            style="padding: 8px; margin-right: 5px; height: 37px"
            >更新</vs-button
          >
          <vs-button
            @click="activePopup = false"
            icon="cancel"
            color="lightgrey"
            style="padding: 8px; margin-right: 5px; height: 37px"
            >閉じる</vs-button
          >
        </div>
      </div>
    </vs-popup>

    <!-- AgGrid Table -->
    <ag-grid-vue
      id="myGrid"
      ref="agGridTable"
      :components="components"
      :gridOptions="gridOptions"
      class="ag-theme-material w-100 my-4 ag-grid-table database"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="settingsData"
      rowSelection="multiple"
      colResizeDefault="shift"
      :animateRows="true"
      :pagination="true"
      :domLayout="domLayout"
      :paginationPageSize="paginationPageSize"
      :suppressPaginationPanel="true"
      :enableRtl="$vs.rtl"
      @selection-changed="onSelectionChanged"
      @sortChanged="onSortChangedEvent"
      :overlayNoRowsTemplate="noRowsTemplate"
      :detailRowAutoHeight="true"
    >
    </ag-grid-vue>

    <div style="position: relative">
      <!-- ITEMS PER PAGE -->
      <div>
        <div class="flex items-center justify-between">
          <span class="pl-2 mr-2" style="font: 400 13.3333px Arial"
            >{{ totalRow }} 件中 {{ startRow }} 件から
            {{ endRow }} 件までを表示</span
          >
        </div>
      </div>
      <!-- pagination -->
      <vs-pagination
        :total="totalPages"
        v-model="currentPage"
        :max="7"
        class="pr-10 pt-10"
      />
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import { AgGridVue } from "ag-grid-vue";
import vSelect from "vue-select";
import EventBus from "../../../EventBus";
import { mapActions, mapGetters } from "vuex";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Japanese } from "flatpickr/dist/l10n/ja.js";

// Cell Renderer
import CellRendererActions from "@/components/cell-renderer/CellRendererActions.vue";

export default {
  components: {
    AgGridVue,
    vSelect,
    // Cell Renderer
    CellRendererActions,
    flatPickr
  },
  data() {
    return {
      configDate: {
        locale: Japanese,
        wrap: true,
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        minTime: "00:15",
      },
      activePopup: false,
      activeDelete: false,
      submitted: false,
      title: "",
      id: null,
      ids: [],
      key: null,
      value: null,
      explanation: null,
      state_flg: 0,

      paginationOptions: [10, 20, 30, 50],

      //SortServer
      orderBy: "id",
      orderDir: "asc",

      //Pagination
      paginationPageSize: 10,
      pageNumber: 1,
      startRow: 0,
      endRow: 0,

      // AgGrid
      noRowsTemplate: "<span>データがありません</span>",
      domLayout: "autoHeight",
      gridApi: null,
      gridOptions: {
        onGridSizeChanged: () => {
          this.gridApi.sizeColumnsToFit();
        },
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        sortingOrder: ["asc", "desc"],
      },
      columnDefs: [
        {
          headerName: "キー",
          field: "key",
          filter: true,
          width: 50,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "値",
          field: "value",
          filter: true,
          width: 50,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "備考",
          field: "explanation",
          filter: true,
          width: 100,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "",
          field: "transactions",
          width: 15,
          cellRendererFramework: "CellRendererActions",
          cellRendererParams: {
            hideDelete: true,
          },
          unSortIcon: false,
          suppressMovable: true,
        },
      ],

      // Cell Renderer Components
      components: {
        CellRendererActions,
      },
      upload_max_filesize: 0
    };
  },
  watch: {
    paginationPageSize(val) {
      this.setPagination(val);
    },
  },
  computed: {
    ...mapGetters({
      getSettings: "settings/getSettings",
    }),
    validateForm() {
      return !this.errors.any();
    },
    settingsData() {
      let settingsData = [];
      this.$store.state.settings.settings.forEach((element) => {
        settingsData.push(Object.assign(element));
      });
      return settingsData;
    },
    totalPages() {
      return parseInt(this.$store.state.settings.infoDB.totalPage);
    },
    totalRow() {
      return parseInt(this.$store.state.settings.infoDB.totalRow);
    },
    currentPage: {
      get() {
        return this.pageNumber;
      },
      async set(val) {
        this.pageNumber = val;
        await this.searchSettingsWithOrder();
        this.ids = [];
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    ...mapActions({
      addSettings: "settings/addSettings",
      updateSettings: "settings/updateSettings",
      showSettings: "settings/showSettings",
      fetchSettings: "settings/fetchSettings",
      removeSettings: "settings/removeSettings",
      fetchUploadMaxFileSize: "settings/fetchUploadMaxFileSize",
    }),
    onSelectionChanged() {
      this.ids = this.gridApi.getSelectedRows().map((setting) => setting.id);
    },
    onSortChangedEvent(event) {
      let columns = event.columnApi.getAllColumns();
      let root = this;
      columns.forEach(function (column) {
        if (column.getSort()) {
          root.orderDir = column.getSort();
          root.orderBy = column.getColId();
          root.searchSettingsWithOrder();
          return;
        }
      });
    },
    async searchSettingsWithOrder() {
      await this.fetchSettings({
        orderBy: this.orderBy,
        orderDir: this.orderDir,
        state_flg: this.state,
        limit: this.paginationPageSize,
        page: this.pageNumber,
      });
    },
    setUpCreate() {
      // clear all fields before create
      (this.state_name = "無効"),
        (this.id = null),
        (this.key = null),
        (this.value = null),
        (this.explanation = null),
        (this.state_flg = 0),
        (this.submitted = false),
        (this.title = "Create setting");
      this.activePopup = true;
    },
    async actionCreate() {
      if (!this.validateForm) {
        this.submitted = true; // first: no show error => after submitted: show error
      } else {
        const checkUploadMaxFilesize =  this.notifyUploadMaxFilesizeFaild();
        if(!checkUploadMaxFilesize) return;
        let data = {
          key: this.key,
          value: this.value,
          explanation: this.explanation,
        };
        await this.addSettings(data);
        this.activePopup = false;
        await this.searchSettingsWithOrder();
      }
    },
    async actionUpdate() {
      const checkUploadMaxFilesize = await this.notifyUploadMaxFilesizeFaild();
      if(!checkUploadMaxFilesize) return;
      await this.updateSettings({
        id: this.id,
        key: this.key,
        value: this.value,
        explanation: this.explanation,
      });
      this.activePopup = false;
      this.ids = [];
      await this.searchSettingsWithOrder();
    },
    notifyUploadMaxFilesizeFaild()
    {
      if(this.key == 'maximum_size_attachment' && ( Number(this.value) == 0 ||  Number(this.value) > Number(this.upload_max_filesize) )){
        this.$vs.notify({
          position: 'bottom-right',
          text: '数値は1から'+this.upload_max_filesize+'まで入力してください。',
          color: 'danger'
        })
        return false;
      }else{
        return true;
      }
    },
    async confirmDelete() {
      await this.deleteSelect();
      this.activeDelete = false;
      this.activePopup = false;
    },
    async deleteSelect() {
      await this.removeSettings(this.ids);
      this.gridApi.deselectAll();
      this.ids = [];
      await this.searchSettingsWithOrder();
    },
    async setPagination(val) {
      this.gridApi.paginationSetPageSize(val);
      this.pageNumber = 1;
      await this.searchSettingsWithOrder();
      this.ids = [];
    },
    editListener(id){
      this.showSettings(id).then((setting) => {
        this.id = setting.id;
        this.state_flg = setting.state_flg;
        this.state_name =
          setting.state_flg == 1 || parseInt(setting.state_flg) == 1
            ? "有効"
            : "無効";
        this.key = setting.key;
        this.value = setting.value;
        this.explanation = setting.explanation;
        this.title = "設定更新";
        this.submitted = true;
        this.activePopup = true;
      })
    },
    deleteListener(id){
      this.activeDelete = true
    },
    async initFetchUploadMaxFileSize(){
      await this.fetchUploadMaxFileSize().then((fileSize) => {
        this.upload_max_filesize = fileSize;
      }).catch(error =>{
        console.log("fetch UploadMaxFileSize failed", error.message[0])
      })
    },
  },
  mounted() {
    this.initFetchUploadMaxFileSize(); // PAC_21-109
    this.gridApi = this.gridOptions.api;
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
    EventBus.$on("editRecord", this.editListener);
    EventBus.$on("deleteRecord", this.deleteListener);
    // save paginationSize to sessionStorage (when fresh browser)
    const root = this;
    window.addEventListener("beforeunload", function () {
      sessionStorage.setItem("paginationPageSize", root.paginationPageSize);
    });
  },
  async created() {
    await this.searchSettingsWithOrder();
  },
  beforeMount() {
    // set page after load (change route = 10, refresh = save PaginationSize in SessionStorage )
    let paginationPageSize = sessionStorage.getItem("paginationPageSize");
    if (paginationPageSize !== null)
      this.paginationPageSize = paginationPageSize;
  },
  updated() {
    // set paginationPageSize = 10 (default) when change page/route
    sessionStorage.setItem("paginationPageSize", 10);
    // calc number startRow and endRow
    this.$nextTick(() => {
      if (!this.$store.state.loading && this.settingsData.length > 0) {
        this.startRow =
          this.pageNumber * this.paginationPageSize -
          this.paginationPageSize +
          1;
        if (this.settingsData.length == this.paginationPageSize)
          this.endRow = this.pageNumber * this.paginationPageSize;
        else
          this.endRow =
            this.paginationPageSize * this.pageNumber +
            this.settingsData.length -
            this.paginationPageSize;
      }
      if (this.settingsData.length == 0) {
        this.endRow = 0;
        this.startRow = 0;
      }
    });
  },
  beforeDestroy(){
    EventBus.$off("editRecord", this.editListener);
    EventBus.$off("deleteRecord", this.deleteListener);
  },
  destroyed() {
    // hiden popup while edit/update => click back/next on broswer (use activePopup = false not working)
    document.getElementById("dialogDelete").style.display = "none";
    document.getElementById("dialogUpdate").style.display = "none";
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/view/settings.scss";
</style>
